<template>
  <div class="hp_alertPopupWrap"> <!-- alert-popup -->
    <div class="hp_alertPopupBox"> <!-- popup-content -->
      <div class="hp_alertPopup_containerBox" @click="navigateToLink"> <!-- image-container -->
        <img :src="images[currentImage].popup_image" alt="알림 이미지" />
        <button class="hp_alertPopup_cbClose" @click.stop="closePopup(false)">close</button>
        <button class="hp_alertPopup_cbArrowLeft" @click.stop="prevImage">next</button>
        <button class="hp_alertPopup_cbArrowRight" @click.stop="nextImage">right</button>
      </div>
      <div class="hp_alertPopup_btnBox"> <!-- bottom-buttons -->
        <button @click="closePopup(true)">오늘 하루 동안 열지 않기</button>
        <button @click="closePopup(false)">닫기</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import {
  get_popup_use
} from '../../ETC/Axios.vue'

export default {
  name: 'AlertPopup',
  data () {
    return {
      currentImage: 0,
      images: []
    }
  },
  methods: {
    closePopup (doNotShowToday) {
      this.$emit('close', doNotShowToday)
    },
    nextImage () {
      this.currentImage = (this.currentImage + 1) % this.images.length
    },
    prevImage () {
      this.currentImage = (this.currentImage - 1 + this.images.length) % this.images.length
    },
    navigateToLink () {
      window.open(this.images[this.currentImage].popup_link, '_blank')
    }
  },
  mounted () {
    get_popup_use().then(result => {
      if (result.length !== 0) {
        this.images = result
      }
    })
  }
}
</script>

<style scoped>
.hp_alertPopupWrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1000;
}

.hp_alertPopupWrap button{
  cursor:pointer;
}

.hp_alertPopupBox {
  position:absolute;
  top:50%;
  left:50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 400px;
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.2);
  text-align: center;
  border-radius: 14px;
  overflow: hidden;
}

.hp_alertPopup_containerBox {
  position: relative;
  width: 100%;
  height: 90vw;
  overflow: hidden;
  cursor: pointer;
}

.hp_alertPopup_containerBox img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hp_alertPopup_cbClose {
  width:28px;
  height:28px;
  background-color:#f5f5f5;
  background-image: url(../../../assets/images/icon/icon_closeBlack.png);
  background-repeat: no-repeat;
  background-position:center;
  background-size:24px;
  border-radius:30px;
  text-indent: -9999px;
  position: absolute;
  top: 10px;
  right: 10px;
}

.hp_alertPopup_cbArrowLeft,
.hp_alertPopup_cbArrowRight {
  width:30px;
  height:30px;
  background-repeat:no-repeat;
  background-size:22px;
  text-indent: -9999px;
  border-radius:30px;
  position: absolute;
  top: 50%;
  opacity:0.6;
  transform: translateY(-50%);
}

.hp_alertPopup_cbArrowLeft{
  background-image:url(../../../assets/images/icon/icon_arrowPrev.png);
  background-position: 2px center;
  left: 10px;
}

.hp_alertPopup_cbArrowRight {
  background-image:url(../../../assets/images/icon/icon_arrowNext.png);
  background-position: 4px center;
  right: 10px;
}

.hp_alertPopup_containerBox button:hover{
  opacity:0.8;
}

.hp_alertPopup_btnBox {
  display: flex;
}

.hp_alertPopup_btnBox button {
  width:50%;
  height:50px;
  font-size: 14px;
  border: none;
  transition: all 0.3s;
}

.hp_alertPopup_btnBox button:first-child {
  background-color: #f5f5f5;
  color: #555;
}

.hp_alertPopup_btnBox button:first-child:hover {
  background-color: #e0e0e0;
}

.hp_alertPopup_btnBox button:last-child {
  background-color: #f04d22;
  color:#fff;
}

.hp_alertPopup_btnBox button:last-child:hover {
  background-color: #d7441b;
}

@media (min-width: 769px) {
  .hp_alertPopup_containerBox {
    width:400px;
    height:400px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Homepage/Section/AlertPopup.vue